import script from "./PublicProjectsExplorer.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicProjectsExplorer.vue?vue&type=script&setup=true&lang=js"

import "./PublicProjectsExplorer.vue?vue&type=style&index=0&id=fd21405a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd21405a"]])

export default __exports__